
export class AuthorityOrderCountVm {
    IsAuthorityOrderCountReached: boolean = false;
};